export const SET_EXPENSE_RECEIPT_ATTACHMENT_IDS =
  'app/updateVirtualCard/SET_EXPENSE_RECEIPT_ATTACHMENT_IDS'
export interface SetExpenseReceiptAttachmentIdsAction {
  type: typeof SET_EXPENSE_RECEIPT_ATTACHMENT_IDS
  payload: {
    ids: string[]
  }
}
export const createSetExpenseReceiptAttachmentIds = (
  ids: string[],
): SetExpenseReceiptAttachmentIdsAction => ({
  type: SET_EXPENSE_RECEIPT_ATTACHMENT_IDS,
  payload: {
    ids,
  },
})
